import React from 'react'
import { Spinner } from 'reactstrap'

export default function OfficialLetterSubmitOverlay({ isOpen, message = 'Salvando ofício...' }) {
  if (!isOpen) return null

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 99999,
      }}
    >
      <div
        style={{
          background: '#fff',
          padding: '20px 28px',
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        }}
      >
        <Spinner color="primary" />
        <span>{message}</span>
      </div>
    </div>
  )
}
